module.exports = __webpack_public_path__ + "static/media/pin-icon.16c4c36b.svg";